/** Mirrors `PaymentStatus` in prisma/schema.prisma. */
export type PaymentStatusT = 'PAID' | 'PENDING' | 'CANCELLED';

/** Mirrors `RefundState` in prisma/schema.prisma. */
export type RefundStateT = 'PENDING' | 'SUCCEEDED' | 'FAILED';

/**
 * Payment row as returned by GET /manage-payments/details/:id (the Prisma
 * `Payment` model, see prisma/schema.prisma). `amount` is stored in DOLLARS;
 * `refundedAmount` is stored in CENTS to match Stripe's native refund unit.
 * Fields beyond `id`/`amount` are optional — older API deploys may omit them.
 */
export interface PaymentI {
  id: string;
  amount: number;
  paymentTypeId?: number | null;
  createdAt?: string;
  status?: PaymentStatusT;
  bookingId?: string;
  stripePaymentIntentId?: string | null;
  /** Stored in cents (Stripe's native refund unit). */
  refundedAmount?: number | null;
  stripeRefundId?: string | null;
  refundState?: RefundStateT | null;
  tenantId?: string | null;
}
